import type { DropdownData } from '@fitogest/reactive-form-builder/interfaces';
import { list } from '../../../../../common/classes/request-builder';
import { FincasModel } from 'src/app/models/form-common/fincas.module';

export class CompradoresListsDefinition {
    public fincas: DropdownData<FincasModel> = list();
    public tipos: DropdownData<string> = 
        list(['...', null ], 
        ['Comercio', 'Comercio'], 
        ['Proveedor', 'Proveedor'], 
        ['Servicios Agrícolas', 'Servicios Agrícolas']
    );
}